import { Quad } from 'gsap';
import type { RefObject } from 'react';
import { fadeFromTo, fadeTo } from '../../../../util/animation/fade/fade';
import { findTransitionController } from '../../../../util/core-transition-component';

interface MenuOverlayRefs {
  elementRef: RefObject<HTMLDivElement | null>;
  backgroundRef: RefObject<HTMLElement | null>;
  navigationListRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, backgroundRef, navigationListRef }: MenuOverlayRefs,
): void {
  const navigationController = findTransitionController(navigationListRef);

  timeline.add(
    fadeFromTo(elementRef.current as HTMLElement, { duration: 0.05, autoAlpha: true }),
    0,
  );
  timeline.add(
    fadeFromTo(backgroundRef.current as HTMLElement, {
      duration: 0.3,
      ease: Quad.easeInOut,
    }),
    0,
  );
  timeline.add(navigationController?.getTimeline('in') as gsap.core.Timeline, 0.1);
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: MenuOverlayRefs,
): void {
  timeline.add(
    fadeTo(elementRef.current as HTMLElement, {
      duration: 0.3,
      ease: Quad.easeInOut,
      autoAlpha: true,
    }),
  );
}
